/* eslint-disable import/no-anonymous-default-export */
/*
 * Cookie
 */

/** 与 voox-saas 登录写 token 时 domain 规则一致 */
function getTopLevelDomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (parts.length <= 1) {
    return hostname;
  }

  return `.${parts.slice(-2).join(".")}`;
}

function buildCookieString(name, value, options = {}) {
  let str = `${name}=${encodeURIComponent(value)}`;

  if (options.domain) {
    str += `; domain=${options.domain}`;
  }

  str += `; path=${options.path || "/"}`;

  if (options.expires) {
    str += `; expires=${options.expires.toUTCString()}`;
  } else if (options.day !== undefined) {
    const time = new Date();
    time.setTime(time.getTime() + options.day * 24 * 60 * 60 * 1000);
    str += `; expires=${time.toUTCString()}`;
  }

  return str;
}

/**
 * 删除 token（voox-saas 登录写入，domain 为顶级域名）
 * 循环清除直到 document.cookie 里读不到 token
 */
export function removeToken() {
  const name = "token";
  const expired = new Date(0);
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const domains = new Set([null]);

  if (parts.length <= 1) {
    domains.add(hostname);
    domains.add(`.${hostname}`);
  } else {
    domains.add(getTopLevelDomain());
    domains.add(parts.slice(-2).join("."));
    domains.add(hostname);
    domains.add(`.${hostname}`);
  }

  const paths = ["/"];

  const clearOnce = () => {
    domains.forEach((domain) => {
      paths.forEach((path) => {
        const opt = { path, expires: expired };
        if (domain) {
          opt.domain = domain;
        }
        document.cookie = buildCookieString(name, "", opt);
      });
    });
  };

  let tries = 0;
  while (tries < 12) {
    clearOnce();
    if (!document.cookie.match("(?:^|;)\\s*token=([^;]*)")) {
      break;
    }
    tries += 1;
  }
}

export default {
  read: function (name) {
    var value = document.cookie.match("(?:^|;)\\s*" + name + "=([^;]*)");
    return value ? decodeURIComponent(value[1]) : null;
  },
  write: function (name, v, value = {}) {
    const options = { ...value };
    if (!options.domain) {
      options.domain = getTopLevelDomain();
    }
    document.cookie = buildCookieString(name, v, options);
    return;
  },
  del: function (name) {
    if (name === "token") {
      removeToken();
      return;
    }
    const expired = new Date(0);
    document.cookie = buildCookieString(name, "", {
      path: "/",
      expires: expired,
      domain: getTopLevelDomain(),
    });
  },
};
